import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { STATIC_STRINGS } from "@asez/shared";

const RenderError = () => {
  return (
    <div className="p-2 mt-4 text-sm xl:text-base w-full mx-auto">
      <div className="w-[800px] h-[400px] mx-auto flex flex-col flex-1 items-center justify-center text-sm xl:text-base">
        <ErrorOutlineIcon color="error" fontSize="large" />
        <h2 className="text-lg font-semibold text-red-600 mt-2">
          {STATIC_STRINGS.ERROR_MESSAGE}
        </h2>
        <p className="text-gray-600 mt-1">
          {STATIC_STRINGS.CANDIDATE_API_ERROR}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="btn btn-outline mt-2"
        >
          {STATIC_STRINGS.RETRY}
        </button>
      </div>
    </div>
  );
};

export default RenderError;
